import React, {Component} from 'react';
import Banner from './Banner';
import MobileMegaNav from './MobileMegaNav';
import CurrentConditions from './CurrentConditions';
import Cannonicalize from '../Cannonicalize'
import OutsideScriptManager from '../OutsideScriptManager'
import {Schedule} from './UtilityBeltSchedule';
import Closings from './Closings';
// import WatchLive from './WatchLive';
import Analytics from '../Analytics'
import Url from '../Url'
// import Bot from '../Bot'

/* ,
                            {
                                "type": "xml",
                                "url": "https://kotv.com/api/GetForecast.ashx?target=data&action=WxForecast2012&site=2&zip=73179"
                            } */

class Header extends Component {
  constructor(props) {
    super(props)
    this.state = {
      mobileMegaNavOpen: false,
      banners: Cannonicalize.banner(),
      hideHeader: false,
      metar: {}
    }

    if(this.props.affiliate == 'kotv')
      this.schedule = Schedule.kotv;
    else
      this.schedule = Schedule.kwtv;


  }

  makeReadable(d){
    let text = d.toLocaleTimeString('en-US').split(' ');
    let letters = text[0].split('');
    letters.splice(-3);
    letters = letters.join('')
    letters = letters.replace(':00','') //only show the :30, otherwise round it off
    if(text[1])
      return letters  + text[1]; //for some reason getting 'undefined on text[1] server-side only'
    else
      return letters
  }

  nextLive(){
    var now = new Date();
    var nextLiveDate = this.schedule[0];
    for (var i = 1; i < this.schedule.length; i++) {
      if(this.schedule[i].getTime() > now.getTime()){
        nextLiveDate = this.schedule[i];
        break;
      }
    }
    return this.makeReadable(nextLiveDate)
  }

  componentWillMount() {
    try {
      this.setState({
        banners: Cannonicalize.banner(this.props.FRN_rawResponses[0].data),
        hideHeader: Url.params(this.props.FRN_page).hideHeader === "true",
        metar: Cannonicalize.metar(this.props.FRN_rawResponses[1].data)
      })
    } catch (e) {
      e.message+= 'in Header'
      Analytics.reportError(e)
    }

  }

  componentDidMount() {
    if (typeof window == 'object' && this.state.hideHeader !== true) {
      try{  this.createHeaderAd()}
      catch(e){
        e.message += 'in Header Advert'
        Analytics.reportError(e)
      }
    }
    // console.log('before update banner', this.state.banners);
  }

  createHeaderAd() {
      window.gptadslots = window.gptadslots || [];
      window.googletag = window.googletag || {
        cmd: []
      };
      //dont show for nativo
      if((window.location.pathname == "/sponsored") || (window.location.search.indexOf('ntv_a') > -1))
        return
      if(window.innerWidth <= 991)
        this.createSmallAd()
      if(window.innerWidth >= 1200)
        this.createLargeAd()


  }


  createLargeAd =()=> {

    googletag.cmd.push(()=> {
      let contentClassification = ''
      try{
        contentClassification = window.franklyDataLayer[0].content_classification.replace(/[ ?/]/gi, '').toLowerCase();
        if(contentClassification == "undefined")
          throw new Error('contentClassification from franklyDataLayer is "undefined"')
      } catch(e){
        console.log('contentClassification not found, using default', e);
      }
      gptadslots.push(googletag.defineSlot('/43459271/loc-desktop/'+this.props.affiliate+ '/web/' + contentClassification, [
        [728, 90]
      ], 'header-ad-container-lg').addService(googletag.pubads()));
      // console.log('Header updated createLargeAd used %s','/43459271/loc-desktop/'+this.props.affiliate+ '/web/' + contentClassification)
      googletag.pubads().setTargeting('wnsz',['41']).enableSingleRequest();
      googletag.enableServices();
    });

    window.googletag.cmd.push(function() {
      googletag.display('header-ad-container-lg')
    }); //large header ad

  }

  bannersUpdated = (banners) =>{
    //this is kind of an oddball to pass changes back up from banners
    // console.log('BannersUpdated in Header index.js',banners);
    this.setState({banners: banners})
  }

  createSmallAd = () => {

    googletag.cmd.push(()=> {
      let contentClassification = ''
      try{
        contentClassification =window.franklyDataLayer[0].content_classification.replace(/[ ?/]/gi, '').toLowerCase();
      } catch(e){
          console.log('contentClassification not found, using default', e);
      }
      gptadslots.push(googletag.defineSlot('/43459271/loc-desktop/'+this.props.affiliate+ '/web/' + contentClassification, [
        [320, 50]
      ], 'header-ad-container-sm').addService(googletag.pubads()));
      // console.log('Header createSmallAd used %s','/43459271/loc-desktop/'+this.props.affiliate+ '/web/' + contentClassification)
      googletag.pubads().setTargeting('wnsz',['41']).enableSingleRequest();
      googletag.enableServices();
    });
    googletag.cmd.push(function() {
      googletag.display('header-ad-container-sm');
    });
  }

  toggleMobileMegaNav = () => {
    this.setState({
      mobileMegaNavOpen: !this.state.mobileMegaNavOpen
    })
  }


  render() {
    if(this.state.hideHeader === true) //This removes the header padding, that is normally set in 'Banner'
      return <div dangerouslySetInnerHTML={{__html: `
                <style>
                  #gnm-main-body, .PageGrid.PageBody.container{
                    padding-top: 0px;
                  }
                </style>
              `}}></div>

    return (<div className='gnm-header'>
      <Banner affiliate={this.props.affiliate} bannersUpdated={this.bannersUpdated} bannersFeed={this.state.banners} watchLiveSponsorship={this.props.watchLiveSponsorship} closingsSponsorship={this.props.closingsSponsorship}/>
      <div id='gnm-header-without-banner'>
        <Closings affliate={this.affiliate}
            closingsSponsorship={this.props.closingsSponsorship}
            banners={this.state.banners} style={{
            height: this.state.schoolsClosed ? '40px' : '0px'
          }}/>
        <div className='container'>
          <div className='pull-left'>
            <button onClick={this.toggleMobileMegaNav.bind(this)} className={'dark-icon-bar-container ' + (
                this.state.mobileMegaNavOpen
                ? 'active'
                : '')}>
              <div className='dark-icon-bar'/>
              <div className='dark-icon-bar'/>
              <div className='dark-icon-bar'/>
              <span>MENU</span>
            </button>
          </div>
          <div className='pull-left  '>
            <a href={this.props.origin}>
              <img src={this.props.newLogo} className='primary-logo img-responsive hidden-xl' style={{maxWidth: '50px'}}/>
              <img src={this.props.newWideLogo} className='primary-logo wide img-responsive visible-xl-block' style={{maxWidth: '148px'}}/>
            </a>
          </div>
          <div className='watch-live pull-left'>
            <a href={this.props.fullLiveStreamList} className='white' style={{display: !this.state.banners.live ? 'block': 'none'}} >
              <img src="https://ftpcontent.worldnow.com/griffin/NEXGEN_Images/WL-OFF.svg"  />
              <div className="upper" >LIVE</div>
              <div className=" lower">@{this.nextLive()}</div>
            </a>
            <a href={this.state.banners.liveUrl} style={{display: this.state.banners.live ? 'block': 'none'}} className='white live-now'>
              <img src="https://ftpcontent.worldnow.com/griffin/NEXGEN_Images/WL-N.svg" />
              <div className="upper">LIVE</div>
              <div className=" lower">NOW</div>
            </a>
          </div>
          <div className='pull-left visible-lg-block'>
            <div className="ad728" id='header-ad-container-lg'/>
          </div>
          <div className='pull-left visible-sm-block'>
            <div className='ad320' id='header-ad-container-sm'/>
          </div>
          <div className='pull-right'>
            <CurrentConditions affiliate={this.props.affiliate} currentConditionsImage={this.props.currentConditionsImage} metar={this.state.metar}/>
          </div>
        </div>
      </div>

      <MobileMegaNav affiliate={this.props.affiliate} nav={this.props.nav} open={this.state.mobileMegaNavOpen} toggle={this.toggleMobileMegaNav}/>
    </div>);
  }
}

export default Header;



// WEBPACK FOOTER //
// ./app/components/custom/ssr/Header/index.js